"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELayerType = exports.ELayoutPhase = void 0; // Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var ELayoutPhase;
exports.ELayoutPhase = ELayoutPhase;

(function (ELayoutPhase) {
  ELayoutPhase["NoData"] = "NoData";
  ELayoutPhase["CalcSizes"] = "CalcSizes";
  ELayoutPhase["CalcPositions"] = "CalcPositions";
  ELayoutPhase["CalcEdges"] = "CalcEdges";
  ELayoutPhase["Done"] = "Done";
})(ELayoutPhase || (exports.ELayoutPhase = ELayoutPhase = {}));

var ELayerType;
exports.ELayerType = ELayerType;

(function (ELayerType) {
  ELayerType["Html"] = "html";
  ELayerType["Svg"] = "svg";
})(ELayerType || (exports.ELayerType = ELayerType = {}));